import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { CoreOffcanvasComponent } from '../../../../ui-components/core-offcanvas/core-offcanvas.component';
import { AddressAutocompleteComponent } from '../../../../ui-components/address-autocomplete/address-autocomplete.component';
import { MernisQueryComponent } from '../../../../shared/components/mernis-query/mernis-query.component';
import { ParameterService } from '../../../../shared/services/parameter/parameter.service';
import { AppMessageService } from '../../../../shared/services/app-message/app-message.service';
import { CountryService } from '../../../../shared/services/location/country.service';
import { PatientService } from '../services/patient.service';
import { IcdCodeListComponent } from '../../../../shared/components/icd-code/icd-code-list/icd-code-list.component';
import { PhoneNumbersComponent } from '../../../../shared/components/phone-numbers/phone-numbers.component';
import { OverlayPanel } from 'primeng/overlaypanel';
import { PatientAddressesComponent } from '../patient-addresses/patient-addresses.component';
import { PhoneListComponent } from '../../../../shared/components/phone-list/phone-list.component';
import { EmailListComponent } from '../../../../shared/components/email-list/email-list.component';
import { AddressListComponent } from '../../../../shared/components/address-list/address-list.component';
import { MedicalRecordsComponent } from '../../../../shared/components/medical-records/medical-records.component';
import { ActivatedRoute } from '@angular/router';
import { CaseStatusesEnum } from '../../../case/interfaces/interfaces';
import { InstituationService } from '../../../instituation/services/institiuation.service';
import { CaseService } from '../../../case/services/case.services';
import { TranslateService } from '@ngx-translate/core';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { CaseStatusPipe } from '../../../../shared/pipes/case-status.pipe';
import { IPatient } from '../interface/patient.interface';
import { PatientSpecialCategoryTagsService, SpecialCategoryTagItem, SpecialCategoryTagLogView } from '../services/patient-special-cateory-tags.service';

type Child = {
  data: string;
  key: string;
  count: number;
};

type CaseItem = {
  key: string;
  label: string;
  children: Child[];
};

@Component({
  selector: 'app-patient-create',
  templateUrl: './patient-create.component.html',
  styleUrl: './patient-create.component.scss',
  providers:[CaseStatusPipe]
})
export class PatientCreateComponent implements OnInit, AfterViewInit {
  @Output() saved = new EventEmitter<IPatient>();
  @ViewChild('canvas') canvas: CoreOffcanvasComponent;
  @Output() saveOn = new EventEmitter<any>();
  @ViewChild('phoneList') phoneListComponent: PhoneListComponent;
  @ViewChild('emailList') emailListComponent: EmailListComponent;
  @ViewChild('addressList') addressListComponent: AddressListComponent;
  @ViewChild('medicalRecord') medicalRecordsComponent: MedicalRecordsComponent;
  @ViewChild('patientAddresses')
  patientAddressesComponent: PatientAddressesComponent;
  @ViewChild('mernisQuery') mernisQueryComponent: MernisQueryComponent;
  @ViewChild('icdCode') icdCodeListComponent: IcdCodeListComponent;
  @ViewChild('addressComponent') addressComponent: AddressAutocompleteComponent;
  @ViewChild('contactComponentPhone')
  contactComponentPhone: PhoneNumbersComponent;
  @ViewChild('contactComponentRelativePhone')
  contactComponentRelativePhone: PhoneNumbersComponent;
  @ViewChild('contactComponentEmail')
  contactComponentEmail: PhoneNumbersComponent;
  @ViewChild('op') op = OverlayPanel;

  isSubmitTriggered: boolean = false;
  isSubmit: boolean = false;
  isQueryMade: boolean = false;
  isSuccess: boolean = false;
  selectedTab: 'patient' | 'case' | 'specialCategoryTags'= 'patient';
  header: string;
  showPassportField = false;
  calculatedAge: number | null = null;
  mode: 'edit' | 'create' | undefined;
  patientForm: FormGroup;
  updatedId: number | null = null;
  maxDate: string;
  genders: { label: string; value: string }[] = [
    { label: 'Erkek', value: 'Male' },
    { label: 'Kadın', value: 'Female' },
  ];
  category: { label: string; value: number }[] = [];
  maritalStatuses: { label: string; value: string }[] = [
    { label: 'Evli', value: 'Married' },
    { label: 'Bekar', value: 'Single' },
    { label: 'Dul', value: 'Widow' },
  ];
  countries: any[] = [];
  initialForm = {
    firstName: '',
    lastName: '',
    idNumber: '',
    idNumberVerified: false,
    birthDate: '',
    isForeignNational: false,
    countryId: null,
    passportNo: '',
    contacts: [],
    addresses: [],
    gender: null,
    birthPlace: '',
    maritalStatus: null,
    mothersName: '',
    fathersName: '',
    categoryId: [],
    medicalRecords: [],
    specialCategoryTags: [],

  };
  titles: { label: string; value: number }[] = [];
  phoneTypes: { label: string; value: number }[] = [];
  emailTypes: { label: string; value: number }[] = [];
  icdCodes: any[] = [];

  //////////////////////////////
  first = 0;
  rows = 10;
  totalCaseRecords: number = 0;
  caseTypes: any[] = [];
  caseStatuses: { label: string; value: CaseStatusesEnum }[] = [];
  instituationList: any[] = [];

  caseFilter: {
    caseType: number | null;
    caseStatus: number | null;
    startDate: Date | null;
    endDate: Date | null;
    callingInstitution: number | null;
    dropoffInstitution: number | null;
    pickupInstitution: number | null;
  } = {
    caseType: null,
    caseStatus: null,
    startDate: null,
    endDate: null,
    pickupInstitution: null,
    dropoffInstitution: null,
    callingInstitution: null,
  };

  caseList: any[] = [];
  caseListExcel: any[]=[];
  caseAnalise: {
    pickupInstitutions: any[];
    dropoffInstitutions: any[];
    callingInstitution: any[];
  } = {
    pickupInstitutions: [],
    dropoffInstitutions: [],
    callingInstitution: [],
  };

  specialCategoryTagSubmitted = false;
  specialCategoryTagLogCounts: Record<string, number> = {};
  specialCategoryTagLogDialogVisible = false;
  specialCategoryTagLogsLoading = false;
  selectedSpecialCategoryTagLabel = '';
  selectedSpecialCategoryTagLogs: SpecialCategoryTagLogView[] = [];

  constructor(
    private readonly fb: FormBuilder,
    private readonly parameterService: ParameterService,
    private readonly messageService: AppMessageService,
    private readonly countryService: CountryService,
    private readonly patientService: PatientService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly instituationService: InstituationService,
    private readonly caseService: CaseService,
    private readonly translate: TranslateService,
    private caseStatusPipe: CaseStatusPipe,
      private readonly specialCategoryTagsService: PatientSpecialCategoryTagsService,
  ) {
    this.patientForm = this.fb.group({
      idNumber: ['', Validators.required],
      idNumberVerified: [false],
      birthDate: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      mothersName: [''],
      fathersName: [''],
      birthPlace: [''],
      gender: [null],
      contacts: [
        [
          {
            name: '',
            prefixValue: '',
            phone: '',
            relativePhone: '',
            email: '',
            priority: false,
            type: '',
          },
        ],
        this.contactsValidator,
      ],
      addresses: [
        [
          {
            country: '',
            title: '',
            city: '',
            district: '',
            formattedAddress: '',
            postalCode: '',
            street: '',
            addressDescription: '',
            latitude: null,
            longitude: null,
            isPriority: false,
          },
        ],
        this.addressValidator(),
      ],
      countryId: [null],
      maritalStatus: [null],
      categoryId: [[]],
      specialCategoryTags: [[]],
      isForeignNational: [false],
      passportNo: [''],
      medicalRecords: [
        [
          {
            icdCodeId: '',
            icdCodeName: '',
            icdCode: '',
            description: '',
          },
        ],
      ],
    });

    this.parameterService
      .getParameterValues('data-group', 'caseTypes')
      .subscribe((response) => {
        this.caseTypes = response.datas.values.map((data: any) => {
          return { label: data.valueObject.name.value, value: data.id };
        });
      });
    this.instituationService.getAll().subscribe((res) => {
      if (res.length > 0) {
        this.instituationList = res.map((item: any) => ({
          value: item.id,
          label: item.signboard,
        }));
      }
    });

    this.patientForm
      .get('isForeignNational')
      ?.valueChanges.subscribe((value) => {
        this.showPassportField = value; // Checkbox true ise pasaport alanını göster
        const passportControl = this.patientForm.get('passportNo');
        const countryControl = this.patientForm.get('countryId');

        if (value) {
          passportControl?.setValidators([Validators.required]);
          countryControl?.setValidators([Validators.required]);
        } else {
          passportControl?.clearValidators();
          countryControl?.clearValidators();
          passportControl?.reset();
          countryControl?.reset();
        }

        passportControl?.updateValueAndValidity();
        countryControl?.updateValueAndValidity();
      });

    this.patientForm.get('birthDate')?.valueChanges.subscribe((birthDate) => {
      if (birthDate) {
        this.calculatedAge = this.calculateAge(birthDate);
      } else {
        this.calculatedAge = null;
      }
    });
    this.getTranslatedStatuses();
  }

  getTranslatedStatuses(): void {
    const enumValues: CaseStatusesEnum[] = [
      CaseStatusesEnum.started,
      CaseStatusesEnum.canceled,
      CaseStatusesEnum.finished,
    ];

    const translationKeys = enumValues.map((status) => `case.status.${status}`);

    this.translate.get(translationKeys).subscribe((translations) => {
      this.caseStatuses = enumValues.map((status) => ({
        value: status,
        label: translations[`case.status.${status}`],
      }));
    });
  }

  get phones(): any[] {
    return (
      this.patientForm
        ?.get('contacts')
        ?.value?.filter((contact: any) => contact.phone) || []
    );
  }

  get addresses(): any[] {
    return this.patientForm?.get('addresses')?.value;
  }

  get emailItems(): any[] {
    return (
      this.patientForm
        ?.get('contacts')
        ?.value.filter((contact: any) => contact.email) || []
    );
  }

  get medicalRecords(): any[] {
    return this.patientForm?.get('medicalRecords')?.value || [];
  }

  updatePhoneItems(updatedPhones: any[]): void {
    const allContacts = this.patientForm?.get('contacts')?.value || [];
    const nonPhoneContacts = allContacts.filter(
      (contact: any) => !contact.phone
    );

    const updatedPhoneContacts = updatedPhones.map((phone) => ({
      ...phone,
    }));

    this.patientForm.patchValue({
      contacts: [...nonPhoneContacts, ...updatedPhoneContacts],
    });
  }

  updateAddresses(updatedAddresses: any[]) {
    this.patientForm.patchValue({
      addresses: updatedAddresses,
    });
  }

  updateEmailItems(updatedEmails: any[]): void {
    const allContacts = this.patientForm?.get('contacts')?.value || [];
    const nonEmailContacts = allContacts.filter(
      (contact: any) => !contact.email
    );

    const updatedEmailContacts = updatedEmails.map((email) => ({
      ...email,
    }));

    this.patientForm.patchValue({
      contacts: [...nonEmailContacts, ...updatedEmailContacts],
    });
  }

  async initialize(data?: any): Promise<void> {
    this.selectedTab = 'patient';
    this.setMaxDate();

    if (data) {
      this.setupEditMode(data);
    } else {
      this.setupCreateMode();
    }

    this.openOffcanvas();
  }

  private setupEditMode(data: any): void {
    this.mode = 'edit';
    console.log('last ID: ', data.id);
    this.updatedId = data.id;
     if (this.updatedId) {
      this.loadSpecialCategoryTagLogSummary(data.id);
    }

    this.patientForm.patchValue({
      ...data,
      birthDate: data?.birthDate ? new Date(data.birthDate) : null,
      categoryId: data?.category?.map((c: any) => c.id),
      gender: data?.gender,
      maritalStatus: data?.maritalStatus,
      specialCategoryTags:
        data?.specialCategoryTags?.map((tag: any) =>
          this.specialCategoryTagsService.normalizeTag(tag)
        ) || [],
    });

    this.header = data?.id
      ? ` | ${data.id} - ${data.firstName} ${data.lastName} `
      : '';

    this.handleMernisVerification(data);
    this.patchMernisForm(data);

    this.getCaseList({ first: 0, rows: this.rows });
  }

  private setupCreateMode(): void {
    this.mode = 'create';
    this.updatedId = null;
    this.specialCategoryTagSubmitted = false;
    this.specialCategoryTagLogCounts = {};
    this.selectedSpecialCategoryTagLogs = [];
    this.patientForm.patchValue({ ...this.initialForm });
    this.header = '';
  }

  private handleMernisVerification(data: any): void {
    const verified = Boolean(data?.idNumberVerified);
    this.isQueryMade = verified;
    this.isSuccess = verified;
    this.setFieldsReadonly(verified);
  }

  private patchMernisForm(data: any): void {
    if (!this.mernisQueryComponent) return;

    this.mernisQueryComponent.mernisForm.patchValue({
      birthDate: data?.birthDate ? new Date(data.birthDate) : null,
      idNumber: data?.idNumber ? Number(data.idNumber) : 0,
    });
  }


  ngOnInit() {
    this.parameterService
      .getParameterValues('data-group', 'patient-category')
      .subscribe((res) => {
        this.category = res?.datas?.values.map((data: any) => {
          return { label: data?.valueObject?.name?.value, value: data.id };
        });
      });

    this.parameterService
      .getParameterValues('data-group', 'address-title')
      .subscribe((res) => {
        this.titles = res?.datas?.values.map((data: any) => {
          return {
            label: data?.valueObject?.name?.value,
            value: data?.valueObject?.id?.value,
          };
        });
      });

    this.parameterService
      .getParameterValues('data-group', 'phone-types')
      .subscribe((res) => {
        this.phoneTypes = res?.datas?.values.map((data: any) => {
          return {
            label: data?.valueObject?.name?.value,
            value: data?.valueObject?.id?.value,
            default: data?.valueObject?.default?.value,
          };
        });
      });

    this.parameterService
      .getParameterValues('data-group', 'email-types')
      .subscribe((response) => {
        this.emailTypes = response?.datas?.values.map((data: any) => {
          return {
            label: data?.valueObject?.name?.value,
            value: data?.valueObject?.id?.value,
          };
        });
      });

    // this.icdCodeService.getSelectableList().subscribe((res) => {
    //   this.icdCodes = res.map((icd: any) => ({
    //     icdCodeId: icd.id,
    //     icdCodeName: icd.name,
    //     icdCode: icd.code,
    //     label: `${icd?.code} ${icd.name}`,
    //   }));
    // });

    this.countryService.getAll().subscribe((res) => {
      if (res.length > 0) {
        this.countries = res.map((item: any) => ({
          value: item.id,
          label: item.name,
          flag: item.flag,
        }));
      }
    });
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  setFieldsReadonly(isReadonly: boolean) {
    const fields = [
      'gender',
      'firstName',
      'lastName',
      'mothersName',
      'fathersName',
      'birthPlace',
      'maritalStatus',
    ];
    for(const field of fields){
       const control = this.patientForm.get(field);
      if (control) {
        control[isReadonly ? 'disable' : 'enable'](); // Eğer readonly ise disable, değilse enable
      }
    }
  }

  openOffcanvas() {
    this.canvas.openPopup();
  }

  cancel() {
    this.patientForm.patchValue({ ...this.initialForm });
    this.medicalRecordsComponent.newMedicalRecordItem = false;
    this.medicalRecordsComponent.cancel();
    this.addressListComponent.newAddressItem = false;
    this.phoneListComponent.newPhoneItem = false;
    this.phoneListComponent.cancel();
    this.emailListComponent.newEmailItem = false;
    this.emailListComponent.cancel();
    this.header = '';
    this.mernisQueryComponent.isSubmit = false;
    this.updatedId = null;
    this.isSubmitTriggered = false;
    this.specialCategoryTagSubmitted = false;
    this.specialCategoryTagLogCounts = {};
    this.specialCategoryTagLogDialogVisible = false;
    this.specialCategoryTagLogsLoading = false;
    this.selectedSpecialCategoryTagLabel = '';
    this.selectedSpecialCategoryTagLogs = [];
    this.isSubmit = false;
    if (this.mernisQueryComponent) {
      this.mernisQueryComponent.mernisForm.reset({
        idNumber: '',
        birthDate: '',
      });
    }
    this.isSuccess = false;
    this.isQueryMade = false;
    this.setFieldsReadonly(false);
    this.selectedTab = 'patient';
    this.caseList = [];
    this.caseListExcel = [];
    this.totalCaseRecords = 0;
    this.rows = 10;
    this.first = 0;
    this.caseAnalise = {
      pickupInstitutions: [],
      callingInstitution: [],
      dropoffInstitutions: [],
    };

    this.route.queryParams.subscribe((params) => {
      if (params['openSidebar'] === 'true') {
        window.close();
      }
    });
  }

  contactsValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const contacts = control.get('contacts')?.value || [];
      const hasPhone = contacts.some((contact: any) => !!contact.phone);
      const hasEmail = contacts.some((contact: any) => !!contact.email);

      const errors: any = {};

      if (!hasPhone) {
        errors.missingPhone = true;
      }

      if (!hasEmail) {
        errors.missingEmail = true;
      }

      return Object.keys(errors).length > 0 ? errors : null;
    };
  }

  addressValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const addresses = control.value || [];
      return addresses.length === 0 ? { missingAddress: true } : null;
    };
  }

  setMaxDate() {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = today.getFullYear();

    this.maxDate = `${year}-${month}-${day}`;
  }

  handleQueryResult(response: any) {
    if (response) {
      this.isQueryMade = true;

      const idNumberVerified = response.isVerified;

      let gender = null;
      if (response.Cinsiyet === 'Kadın') {
        gender = 'Female';
      } else if (response.Cinsiyet === 'Erkek') {
        gender = 'Male';
      }

      let maritalStatus = null;
      if (response.MedeniHal === 'Evli') {
        maritalStatus = 'Married';
      } else if (response.MedeniHal === 'Bekâr') {
        maritalStatus = 'Single';
      } else if (response.MedeniHal === 'Boşanmış') {
        maritalStatus = 'Divorced';
      } else if (response.MedeniHal === 'Dul') {
        maritalStatus = 'Widow';
      }

      if (response.isVerified) {
        this.isSuccess = true;
      }

      this.patientForm.patchValue({
        idNumberVerified: idNumberVerified,
        firstName: response.Ad,
        lastName: response.Soyad,
        gender: gender,
        mothersName: response.AnaAd,
        fathersName: response.BabaAd,
        birthPlace: response.DogumYer,
        maritalStatus: maritalStatus,
      });

      if (idNumberVerified) {
        this.patientForm.get('idNumber')?.disable();
        this.patientForm.get('birthDate')?.disable();
        this.patientForm.get('firstName')?.disable();
        this.patientForm.get('lastName')?.disable();
        this.patientForm.get('gender')?.disable();
        this.patientForm.get('mothersName')?.disable();
        this.patientForm.get('fathersName')?.disable();
        this.patientForm.get('birthPlace')?.disable();
        this.patientForm.get('maritalStatus')?.disable();
      } else {
        this.patientForm.get('idNumber')?.enable();
        this.patientForm.get('birthDate')?.enable();
        this.patientForm.get('firstName')?.enable();
        this.patientForm.get('lastName')?.enable();
        this.patientForm.get('gender')?.enable();
        this.patientForm.get('mothersName')?.enable();
        this.patientForm.get('fathersName')?.enable();
        this.patientForm.get('birthPlace')?.enable();
        this.patientForm.get('maritalStatus')?.enable();
      }
    } else {
      this.isSuccess = false;
      this.patientForm.patchValue({
        idNumberVerified: false,
      });
    }
  }

  private validateForeignNational(): boolean {
    if (this.patientForm.get('isForeignNational')?.value) {
      const countryId = this.patientForm.get('countryId')?.value;
      const passportNo = this.patientForm.get('passportNo')?.value;

      return !!(countryId && passportNo);
    }

    return true;
  }

  private processMernisData(): any {
    const mernisForm = this.mernisQueryComponent.mernisForm;
    mernisForm.markAllAsTouched();

    if (mernisForm.invalid) {
      return null;
    }

    return this.mernisQueryComponent.onGetData();
  }

  private validateSpecialCategoryTags(): boolean {
    if (this.hasEmptySpecialCategoryTag()) {
      this.specialCategoryTagSubmitted = true;
      this.patientForm.get('specialCategoryTags')?.markAsDirty();
      this.patientForm.get('specialCategoryTags')?.markAsTouched();
      return false;
    }

    return true;
  }


  private handleFormSubmission(formData: any, isUpdate: boolean): void {
    console.log('Form Data to submit:', formData);
    const serviceMethod = isUpdate
      ? this.patientService.updatePatient.bind(this.patientService)
      : this.patientService.createPatient.bind(this.patientService);

    serviceMethod(formData).subscribe({
      next: (res) => {
        this.saveOn.emit(res);
        this.messageService.successToast(
          'Başarılı',
          isUpdate
            ? 'Kişi başarılı bir şekilde güncellendi.'
            : 'Kişi başarılı bir şekilde kaydedildi.'
        );
        this.afterSave(res);
        this.canvas.closePopup();
      },
      error: (err) => {}
    });
  }

  save() {
    this.isSubmit = true;
    this.isSubmitTriggered = true;
    const contacts = this.patientForm.get('contacts')?.value || [];
    const hasPhone = contacts.some((contact: any) => contact.phone);
    const hasEmail = contacts.some((contact: any) => contact.email);

    const errors: any = {};
    if (!hasPhone) {
      errors.missingPhone = true;
    }

    if (!hasEmail) {
      errors.missingEmail = true;
    }

    if (Object.keys(errors).length > 0) {
      this.patientForm.get('contacts')?.setErrors(errors);
      return;
    }

    const addresses = this.patientForm.get('addresses')?.value || [];

    if (addresses.length === 0) {
      this.patientForm.get('addresses')?.setErrors({ missingAddress: true });
      this.patientForm.markAllAsTouched();
      return;
    }

    if (!this.validateForeignNational()) {
      return;
    }

    const mernisQueryData = this.processMernisData();
    if (!mernisQueryData) {
      return;
    }
    
    if (!this.validateSpecialCategoryTags()) {
      return;
    }

    const formData = {
      ...this.patientForm.value,
      idNumber: mernisQueryData.idNumber,
      birthDate: mernisQueryData.birthDate,
    };

    this.handleFormSubmission(formData, false);
  }

  update() {
    this.isSubmit = true;
    this.isSubmitTriggered = true;
    const addresses = this.patientForm.get('addresses')?.value || [];

    if (addresses.length === 0) {
      this.patientForm.get('addresses')?.setErrors({ missingAddress: true });
      this.patientForm.markAllAsTouched();
      return;
    }

    if (!this.validateForeignNational()) {
      return;
    }

    const mernisQueryData = this.processMernisData();
    if (!mernisQueryData) {
      return;
    }

    const formData = {
      ...this.patientForm.value,
      idNumber: mernisQueryData.idNumber,
      birthDate: mernisQueryData.birthDate,
      id: this.updatedId,
      firstName: this.patientForm.get('firstName')?.value,
      lastName: this.patientForm.get('lastName')?.value,
      gender: this.patientForm.get('gender')?.value,
      mothersName: this.patientForm.get('mothersName')?.value,
      fathersName: this.patientForm.get('fathersName')?.value,
      maritalStatus: this.patientForm.get('maritalStatus')?.value,
      birthPlace: this.patientForm.get('birthPlace')?.value,
    };

    this.handleFormSubmission(formData, true);
  }

  /*  save() {
      this.isSubmit = true;
      this.isSubmitTriggered = true;
      const contacts = this.patientForm.get('contacts')?.value || [];
      const hasPhone = contacts.some((contact: any) => contact.phone);
      const hasEmail = contacts.some((contact: any) => contact.email);

      const errors: any = {};
      if (!hasPhone) {
        errors.missingPhone = true;
      }

      if (!hasEmail) {
        errors.missingEmail = true;
      }

      if (Object.keys(errors).length > 0) {
        this.patientForm.get('contacts')?.setErrors(errors);
        return;
      }

      const addresses = this.patientForm.get('addresses')?.value || [];
      const hasValidAddress = addresses.some(
        (address: any) => address.title && address.city
      );

      if (!hasValidAddress) {
        this.patientForm.get('addresses')?.setErrors({ missingAddress: true });
        return;
      }

      if (this.patientForm.get('isForeignNational')?.value) {
        const countryId = this.patientForm.get('countryId')?.value;
        const passportNo = this.patientForm.get('passportNo')?.value;

        if (!countryId || !passportNo) {
          return;
        }
      }

      const mernisForm = this.mernisQueryComponent.mernisForm;
      mernisForm.markAllAsTouched();

      if (mernisForm.invalid) {
        return;
      }

      const mernisQueryData = this.mernisQueryComponent.onGetData();

      this.patientForm.patchValue({
        ...this.patientForm.value,
        idNumber: mernisQueryData.idNumber,
        birthDate: mernisQueryData.birthDate,
      });

      this.patientService.createPatient(this.patientForm.value).subscribe(
        (res) => {
          this.onSave.emit(res);
          this.messageService.successToast(
            'Başarılı',
            'Kişi başarılı bir şekilde kaydedildi.'
          );
          this.canvas.closePopup();
        },
        (err) => {
        }
      )
    }

    update() {
      this.isSubmit = true;
      this.isSubmitTriggered = true;

      const mernisForm = this.mernisQueryComponent.mernisForm;
      mernisForm.markAllAsTouched();

      if ( mernisForm.invalid) {
        return;
      }
      const mernisQueryData = this.mernisQueryComponent.onGetData();

      if (this.patientForm.get('isForeignNational')?.value) {
        const countryId = this.patientForm.get('countryId')?.value;
        const passportNo = this.patientForm.get('passportNo')?.value;

        if (!countryId || !passportNo) {
          return;
        }
      }

      const addresses = this.patientForm.get('addresses')?.value || [];
      const hasValidAddress = addresses.some(
        (address: any) => address.title && address.city
      );

      if (!hasValidAddress) {
        this.patientForm.get('addresses')?.setErrors({ missingAddress: true });
        return;
      }

      const formData = {
        ...this.patientForm.value,
        idNumber: mernisQueryData.idNumber,
        birthDate: mernisQueryData.birthDate,
        maritalStatusId: Number(this.patientForm.value.maritalStatusId),
        id: this.updatedId
      };

      this.patientService.updatePatient(formData).subscribe(
        (res) => {
          this.onSave.emit(res);
          this.messageService.successToast(
            'Başarılı',
            'Kişi başarılı bir şekilde güncellendi.'
          );
          this.canvas.closePopup();
        },
        (err) => {
        }
      );
    }*/

  calculateAge(birthDate: string): number {
    const today = new Date();
    const birthDateObj = new Date(birthDate);
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDifference = today.getMonth() - birthDateObj.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDateObj.getDate())
    ) {
      age--;
    }

    return age;
  }

  updateMedicalRecords(updatedMedicalRecords: any[]) {
    this.patientForm.patchValue({
      medicalRecords: updatedMedicalRecords,
    });
  }

  setTab(tab: 'patient' | 'case' | 'specialCategoryTags') {
    this.selectedTab = tab;
    setTimeout(() => {
    }, 100);
  }

  clearFilter() {
    this.caseFilter = {
      pickupInstitution: null,
      dropoffInstitution: null,
      callingInstitution: null,
      startDate: null,
      endDate: null,
      caseStatus: null,
      caseType: null,
    };
    this.getCaseList({ first: 0, rows: this.rows });
  }

  getCaseList(event: any) {
    if (this.updatedId) {
      this.first = event?.first ?? 0;
      this.rows = event?.rows ?? 10;
      const sortField = event?.sortField || 'id';
      let sortOrder = 'ASC';

      if (event?.sortOrder === -1) {
        sortOrder = 'DESC';
      }

      const page = Math.floor((this.first ?? 1) / (this.rows ?? 1));

      this.caseService
        .getCaseListByPatientId(this.updatedId, {
          ...this.caseFilter,
          rows: this.rows,
          first: page,
          sortField,
          sortOrder,
        })
        .subscribe((res: any) => {
          this.caseList = res?.items ?? [];
          this.caseListExcel = res?.analize ?? [];
          this.totalCaseRecords = res.total;
          this.analyzeInstitutions(res?.analize ?? []);
        });
    } else {
      this.caseList = [];
      this.caseListExcel = [];
      this.totalCaseRecords = 0;
    }
  }

  analyzeInstitutions(data: any[]): void {
    const pickupMap: Map<number, { signboard: string; count: number }> = new Map();
    const dropoffMap: Map<number, { signboard: string; count: number }> = new Map();
    const callingMap: Map<number, { signboard: string; count: number }> = new Map();

    for (const item of data) {
      this.updateInstitutionMap(pickupMap, item.addressInformations?.pickupInstitution);
      this.updateInstitutionMap(dropoffMap, item.addressInformations?.dropoffInstitution);
      this.updateInstitutionMap(callingMap, item.caseInformations?.institution);
    }

    const mapToArray = (
      map: Map<number, { signboard: string; count: number }>
    ): { id: number; signboard: string; count: number }[] =>
      Array.from(map.entries()).map(([id, value]) => ({
        id,
        signboard: value.signboard,
        count: value.count,
      }));

    this.caseAnalise = {
      pickupInstitutions: mapToArray(pickupMap),
      dropoffInstitutions: mapToArray(dropoffMap),
      callingInstitution: mapToArray(callingMap),
    };
  }

  private updateInstitutionMap(
    map: Map<number, { signboard: string; count: number }>,
    institution?: { id: number; signboard: string }
  ): void {
    if (!institution) return;
    const existing = map.get(institution.id);
    if (existing) {
      existing.count += 1;
    } else {
      map.set(institution.id, { signboard: institution.signboard, count: 1 });
    }
  }

  exportToExcel(): void {
    if (!this.caseListExcel || !this.caseListExcel.length) {
      return;
    }

    const excelData = this.caseListExcel.map(item => ({
      ID: item?.id,
      'Protokol No': item?.caseNo,
      'Vaka Tarihi': item?.caseDate
        ? new Date(item.caseDate).toLocaleDateString('tr-TR')
        : '',
      'Vaka Tipi': item?.caseType?.valueObject?.name?.value ?? '',
      'Vaka Durumu': this.caseStatusPipe.transform(item?.caseStatus),
      'Ad Soyad':
        `${item?.patientInformations?.firstName ?? ''} ${item?.patientInformations?.lastName ?? ''
          }`.trim(),
      'Alındığı Kurum':
        item?.addressInformations?.pickupInstitution?.signboard ?? '',
      'Bırakıldığı Kurum':
        item?.addressInformations?.dropoffInstitution?.signboard ?? '',
      'Çağrı Kurum':
        item?.caseInformations?.institution?.signboard ?? '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    worksheet['!cols'] = [
      { wch: 8 },   // ID
      { wch: 18 },  // Protokol No
      { wch: 14 },  // Vaka Tarihi
      { wch: 22 },  // Vaka Tipi
      { wch: 16 },  // Vaka Durumu
      { wch: 24 },  // Ad Soyad
      { wch: 38 },  // Alındığı Kurum
      { wch: 38 },  // Bırakıldığı Kurum
      { wch: 38 },  // Çağrı Kurum
    ];
    const workbook = {
      Sheets: { Vakalar: worksheet },
      SheetNames: ['Vakalar'],
    };

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    this.saveExcelFile(excelBuffer, 'case-list');
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });

    saveAs(data, `${fileName}_${new Date().getTime()}.xlsx`);
  }

   private afterSave(createdPatient: IPatient) {
    this.saved.emit(createdPatient);
    this.canvas.closePopup();     
  }
  get specialCategoryTagItems(): SpecialCategoryTagItem[] {
    return this.specialCategoryTagsService.getItems(this.patientForm);
  }

  trackBySpecialCategoryTag(
    index: number,
    item?: SpecialCategoryTagItem
  ): string | number {
    return item?.uid ?? index;
  }

  hasEmptySpecialCategoryTag(): boolean {
    return this.specialCategoryTagsService.hasEmptyTag(
      this.specialCategoryTagItems
    );
  }

  isSpecialCategoryTagInvalid(index: number): boolean {
    return this.specialCategoryTagsService.isInvalidTag(
      this.specialCategoryTagItems,
      index,
      this.specialCategoryTagSubmitted
    );
  }

  addSpecialCategoryTag(): void {
    this.specialCategoryTagSubmitted = true;

    this.specialCategoryTagsService.addTag(this.patientForm);
  }

  removeSpecialCategoryTag(index: number): void {
    const isValidAfterRemove = this.specialCategoryTagsService.removeTag(
      this.patientForm,
      index
    );

    if (isValidAfterRemove) {
      this.specialCategoryTagSubmitted = false;
    }
  }

  updateSpecialCategoryTag(
    index: number,
    field: keyof SpecialCategoryTagItem,
    value: string | boolean
  ): void {
    this.specialCategoryTagsService.updateTag(
      this.patientForm,
      index,
      field,
      value
    );
  }

  getSpecialCategoryTagLogCount(item: SpecialCategoryTagItem): number {
    return this.specialCategoryTagsService.getLogCount(
      this.specialCategoryTagLogCounts,
      item
    );
  }

  loadSpecialCategoryTagLogSummary(patientId: number): void {
    this.specialCategoryTagsService.getLogSummary(patientId).subscribe({
      next: (res) => {
        this.specialCategoryTagLogCounts = res || {};
      },
      error: () => {
        this.specialCategoryTagLogCounts = {};
      },
    });
  }

  openSpecialCategoryTagLogs(item: SpecialCategoryTagItem): void {
    if (!this.updatedId || !item?.uid) {
      return;
    }

    this.selectedSpecialCategoryTagLabel = item.label;
    this.selectedSpecialCategoryTagLogs = [];
    this.specialCategoryTagLogDialogVisible = true;
    this.specialCategoryTagLogsLoading = true;

    this.specialCategoryTagsService
      .getLogs(this.updatedId, item.uid)
      .subscribe({
        next: (res) => {
          console.log('Logs for', item.label, res);
          this.selectedSpecialCategoryTagLogs = res || [];
          this.specialCategoryTagLogsLoading = false;
        },
        error: () => {
          this.selectedSpecialCategoryTagLogs = [];
          this.specialCategoryTagLogsLoading = false;
        },
      });
  }

}
